import React from 'react'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { Work } from '@/javascript/domain/entities/work'
import AutocompleteSingleFetchInput from '@/javascript/presentation/components/inputs/autocomplete-single-fetch-input'
import { useRoutingContext } from '../../hooks/use-routing-context'
import { disabledWorkText, validateDuration, workDuration, workSubtitleText } from '../../helpers'
import WorkSelectionTable from './work-selection-table'

const WORK_LIMIT = 2000

const WorkSelectionInput: React.FC = () => {
  const { selectedWorks, setSelectedWorks, setWorkDurations, setDurationErrors, loadWorkList } = useRoutingContext()

  const fetchWorks = (searchText: string) =>
    loadWorkList.load({ searchText, includeTeamWorks: true, includeResourcePlaces: true, statuses: ['not_started'], withoutRoute: true })

  const addWork = (work: Work) => {
    const { duration, error } = validateDuration(workDuration(work.startTime, work.endTime))
    setWorkDurations(prev => ({ ...prev, [work.id]: duration }))
    setDurationErrors(prev => ({ ...prev, [work.id]: error }))
    setSelectedWorks(prev => [...prev, work])
  }

  return (
    <>
      <AutocompleteSingleFetchInput
        data-testid="work-selection-input"
        label="Atividades disponíveis"
        fetchOptions={fetchWorks}
        selectedItems={selectedWorks}
        onSelect={addWork}
        getOptionLabel={(w) => w.title}
        getOptionKey={(w) => w.id}
        getOptionDisabled={(w) => !!disabledWorkText(w)}
        limitReached={selectedWorks.length >= WORK_LIMIT}
        limitTooltip="O limite máximo de atividades selecionadas foi atingido"
        renderOption={(props, option) => {
          const { key, ...optionProps } = props
          const disabledText = disabledWorkText(option)
          return (
            <Tooltip key={key} title={disabledText} placement="right" arrow disableHoverListener={!disabledText}>
              <span>
                <Box component="li" {...optionProps}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <Typography sx={{ fontSize: '1rem' }}>{option.title}</Typography>
                    <Typography sx={{ fontSize: '0.875rem' }}>{workSubtitleText(option)}</Typography>
                  </Box>
                </Box>
              </span>
            </Tooltip>
          )
        }}
      />
      <WorkSelectionTable />
    </>
  )
}

export default WorkSelectionInput
